import { MaintenanceLayout } from './MaintenanceLayout';

interface ConnectionStateProps {
  onTryAgain: () => void;
}

/**
 * Connection state: the user's network is broken (probe to /favicon.ico
 * failed but navigator.onLine === true, e.g., captive portal or DNS issue).
 * No auto-poll: we cannot reach the user's network anyway.
 */
export function ConnectionState({ onTryAgain }: ConnectionStateProps) {
  return (
    <MaintenanceLayout onTryAgain={onTryAgain}>
      <img src="/signup-mascot.svg" alt="" className="w-24 h-24 mx-auto mb-2" aria-hidden="true" />
      {/* h2 (not h1): see MaintenanceState.tsx for outline rationale. */}
      <h2 className="text-xl font-semibold text-gray-900">Trouble connecting.</h2>
      <p className="text-sm text-gray-600">
        Looks like your network&apos;s having a moment. Check your wifi and try again.
      </p>
    </MaintenanceLayout>
  );
}
